import { z } from 'zod';

export const ImportCsvSearchSchema = z.object({
  pageSize: z.number().default(100),
  pageIndex: z.number().default(0),
  filterError: z.boolean().optional(),
  filterWarning: z.boolean().optional(),
});

export type ImportCsvSearchParams = z.infer<typeof ImportCsvSearchSchema>;
